import { types } from 'k-ramel'

export default () => ({
  config: {
    lang: types.string({ defaultData: 'fr-FR' }),
    locale: types.object(),
    keycloak: types.object(),
    keycloakConfig: types.object(),
  },
  data: {
    user: types.object(),
  },
  works: {
  },
  ui: {
    ready: types.bool({ defaultData: false }),
    authorized: types.bool({ defaultData: false }),
    screen: {
      name: types.string({ defaultData: '' }),
      subName: types.string({ defaultData: '' }),
    },
  },
})
